import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';

export const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div className="col-span-1 md:col-span-2">
                        <h3 className="text-2xl font-bold mb-4 text-primary">Yapadra Health</h3>
                        <p className="text-gray-400 max-w-sm">
                            {t('footer.description')}
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold mb-4">{t('footer.quickLinks')}</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li><a href="#" className="hover:text-primary transition-colors">{t('footer.home')}</a></li>
                            <li><a href="#value-props" className="hover:text-primary transition-colors">{t('navbar.benefits')}</a></li>
                            <li><a href="#how-it-works" className="hover:text-primary transition-colors">{t('navbar.howItWorks')}</a></li>
                            <li><a href="#testimonials" className="hover:text-primary transition-colors">{t('navbar.testimonials')}</a></li>
                            <li><a href="#universities" className="hover:text-primary transition-colors">{t('navbar.universities')}</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-4">{t('footer.contact')}</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li className="flex items-center gap-2">
                                <Mail size={16} />
                                <a href="mailto:team@yapadra.health" className="hover:text-primary transition-colors">
                                    team@yapadra.health
                                </a>
                            </li>
                            <li className="flex gap-4 mt-4">
                                <a href="#" className="hover:text-primary transition-colors"><Facebook size={20} /></a>
                                <a href="#" className="hover:text-primary transition-colors"><Twitter size={20} /></a>
                                <a href="#" className="hover:text-primary transition-colors"><Instagram size={20} /></a>
                                <a href="#" className="hover:text-primary transition-colors"><Linkedin size={20} /></a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
                    <p>{t('footer.rights', { year: new Date().getFullYear() })}</p>
                </div>
            </div>
        </footer>
    );
};
